package com.parmartechnologies.core.feature.cart.model

import com.parmartechnologies.core.feature.address.model.Address
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DeliveryOption(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("selected_business_id") var selectedBusinessID: String = "",
    @SerialName("address") var address: Address? = null,
    @SerialName("is_delivery") var isDelivery: Int = 0,
)